import { useContext } from "react";
import DialogContext from "../context/DialogContext";

const useAppDialog = () => useContext(DialogContext)

export default useAppDialog;